import type { ColumnDef } from '@tanstack/vue-table'
import { ConnectedAccountsEmbed } from '../tables/ConnectedAccounts'

// This type is used to define the shape of our data.
// You can use a Zod schema here if you want.
export const connectedAccountsColumns: ColumnDef<ConnectedAccountsEmbed.ListItem>[] = [
  {
    accessorKey: 'businessName',
  },
  {
    accessorKey: 'organizationId',
  },
  {
    accessorKey: 'aliasName',
  },
  {
    accessorKey: 'bban',
  },
  {
    accessorKey: 'currentBalance',
  },
  // {
  //   accessorKey: 'payoutRecipientEmail',
  // },
  {
    accessorKey: 'statusInfo',
    size: 150,
  },
  {
    id: 'actions',
  },
]
